import React from "react";
import { View, Text, StyleSheet, ScrollView, Image } from "react-native";
import { useTranslation } from "react-i18next";
import { useSessionStore } from "../../../../../../state/src/useSessionStore";
import type { SessionState } from "../../../../../../state/src/useSessionStore";
import PinIllustrationIcon from "../../../../../../../assets/images/Illustration.png";
import ApplApsskeyIcon from "../../../../../../../assets/images/Apple-Apsskey-icon.png";

type Props = {};

export default function ConfirmationStep() {
  const { t } = useTranslation();
  const isReceiver = useSessionStore((s: SessionState) => (s as any).isReceiver);
  const isSendCash = useSessionStore((s: SessionState) => (s as any).isSendCash);

  return (
    <View
      style={styles.container}
    >
      {isReceiver ? (
        <View style={{ alignItems: 'center', marginBottom: 200}}>
          <Image source={ApplApsskeyIcon} style={styles.successIconStyle} />
          <Text style={styles.title}>{t("TELL_US_ABOUT_YOUSELF")}</Text>
          <Text style={[styles.subtitle, {width: 287, paddingHorizontal: 16}]}>{t("TRANSACTION_SECURE_AND_PREVENT_FRAUD")}</Text>
        </View>
      ) : (
        <View style={{ alignItems: 'center', marginBottom: 200}}>
          <Image source={PinIllustrationIcon} style={styles.successIconStyle} />
          <Text style={styles.title}>{t("PIN_CREATED")}</Text>
          <Text style={styles.subtitle}>{t("REMEMBER_PIN")}</Text>
        </View>
      )}
    </View>
  );
}


const styles = StyleSheet.create({
  container: {
    marginBottom: 24,
    backgroundColor: "#fff",
    alignItems: 'center'
  },
  successIconStyle: {
    marginTop: 56,
    width: 228,
    height: 228
  },
  content: {
    paddingHorizontal: 24,
    paddingTop: 32,
    paddingBottom: 40,
  },
  check: { fontSize: 36, color: "#555" },
  title: {
    fontFamily: 'Rubik',
    fontSize: 34,
    fontWeight: "600",
    textAlign: "center",
    color: "#1F1F1F",
    marginTop: 24,
    lineHeight: 40,
    width: 287,
    paddingHorizontal: 20
  },
  subtitle: {
    fontFamily: 'Rubik',
    fontSize: 16,
    fontWeight: "400",
    textAlign: "center",
    color: "#1F1F1F",
    width: 279,
    paddingHorizontal: 24,
    lineHeight: 24
  },
});